var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5299 5.98333C19.6466 2.89167 17.0216 0.5 13.9883 0.5C10.9549 0.5 8.27159 2.95 8.44659 5.98333C8.50492 6.625 9.08825 9.65833 9.08825 9.65833C9.55492 12.2833 11.3049 14.5 13.9883 14.5C16.6716 14.5 18.4216 12.2833 18.8883 9.6C18.8883 9.6 19.4716 6.56667 19.5299 5.98333Z",
    fill: "#658479",
    stroke: "#121212",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4046 27.3333H0.571289L1.21296 22.55C1.50462 20.975 2.90462 20.0417 4.47962 19.6917L13.988 18L23.4963 19.6917C25.0713 20.0417 26.4713 20.975 26.7046 22.55L27.4046 27.3333Z",
    fill: "#658479",
    stroke: "#121212",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserHover);
export default __webpack_public_path__ + "static/media/User-hover.99e3248488193ed5d024eb3289667047.svg";
export { ForwardRef as ReactComponent };